export const listConstant = {
  childHeader: 'Gauge Repeatability and Reproducibility Data Sheet',
  addButtonLable: 'New Sheet',
  datePickerLabel: 'Search By Year',
};

export const createConstant = {
  childHeader: 'Gauge Repeatability',
  theadHeader: 'Gauge Repeatability',
};

export const apiConstant = {
  deleteurl: '/api/gaugeRoute',
  gettableDataurl: '/api/gaugeRoute',
  getByid: '/api/gaugeRoute',
  createid: '/api/gaugeRoute',
  updateByid: '/api/gaugeRoute',
};

export const navigationConstant = {
  createPlanSchedule: '/common/createGaugeRepeatability',
};
